import { z } from 'zod';
import { stringArraySchema, timestampSchema } from './shared';
import { claimStatusSchema } from './servicePage';

export const offerRowSchema = z.object({
  slug: z.string().min(1),
  title: z.string().min(1),
  purpose: z.string(),
  bestFor: z.string().nullable(),
  duration: z.string().nullable(),
  outputs: stringArraySchema,
  ctaLabel: z.string().nullable(),
  ctaHref: z.string().nullable(),
  typicalScope: stringArraySchema,
  exclusions: stringArraySchema,
  engagementModel: z.string().nullable(),
  claimStatus: claimStatusSchema.nullable(),
  sortOrder: z.number().int(),
  visible: z.boolean(),
  createdAt: timestampSchema,
  updatedAt: timestampSchema,
});

export const offerInsertSchema = z.object({
  slug: z.string().min(1),
  title: z.string().min(1),
  purpose: z.string(),
  bestFor: z.string().nullable().optional(),
  duration: z.string().nullable().optional(),
  outputs: stringArraySchema.optional(),
  ctaLabel: z.string().nullable().optional(),
  ctaHref: z.string().nullable().optional(),
  typicalScope: stringArraySchema.optional(),
  exclusions: stringArraySchema.optional(),
  engagementModel: z.string().nullable().optional(),
  claimStatus: claimStatusSchema.nullable().optional(),
  sortOrder: z.number().int().optional(),
  visible: z.boolean().optional(),
});

export const offerUpdateSchema = offerInsertSchema.partial();

export type OfferRow = z.infer<typeof offerRowSchema>;
export type OfferInsert = z.input<typeof offerInsertSchema>;
export type OfferUpdate = z.input<typeof offerUpdateSchema>;
